import { render, staticRenderFns } from "./CmgCheckoutHeader.vue?vue&type=template&id=54728d8a&scoped=true&lang=pug"
import script from "./cmg-checkout-header.ts?vue&type=script&lang=ts&external"
export * from "./cmg-checkout-header.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgCheckoutHeader.vue?vue&type=style&index=0&id=54728d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54728d8a",
  null
  
)

export default component.exports